import { DECIMAL_TRAILING_ZEROS, DEFAULT_CURRENCY, DEFAULT_LOCALE, INTEGER_TRAILING_ZEROS } from '../consts/consts';

type PriceFormatOptions = {
	locale?: string;
	currency?: string;
	negative?: boolean;
	withoutTrailingZeros?: boolean;
	style?: 'currency' | 'decimal';
};

export const formatPrice = (
	price: number = NaN,
	{
		locale = DEFAULT_LOCALE,
		currency = DEFAULT_CURRENCY,
		negative = false,
		withoutTrailingZeros = false,
		style,
	}: PriceFormatOptions = {}
) => {
	const minimumFractionDigits: number | undefined = withoutTrailingZeros
		? Number.isInteger(price)
			? INTEGER_TRAILING_ZEROS
			: DECIMAL_TRAILING_ZEROS
		: undefined;

	return Intl.NumberFormat(locale, {
		style: style || 'currency',
		currencyDisplay: 'narrowSymbol',
		currency,
		minimumFractionDigits,
	}).format(negative ? -price : price);
};
